import axiosClient from '../axiosClient';

const orderAPI = {
    async getListOrderAPI(params) {
        const url = `/order`;
        const resp = await axiosClient.get(url, { params });
        return resp;
    },
    async getOneOrderAPI(id, params) {
        const url = `/order/${id}`;
        const resp = await axiosClient.get(url, { params });
        return resp;
    },
    async orderProductAPI(data) {
        const url = `/order`;
        const resp = await axiosClient.post(url, data);
        return resp;
    },
    async cancelOrderAPI(id) {
        const url = `/order/${id}/cancel`;
        const resp = await axiosClient.put(url);
        return resp;
    },
    async receiveOrderAPI(id) {
        const url = `/order/${id}/received`;
        const resp = await axiosClient.get(url);
        return resp;
    },
};

export default orderAPI;
